<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else class="mt-3">
    <div v-show="!isLoading" class="row">
      <div class="d-flex align-items-center justify-content-start col">
        <span style="margin-right: 1rem">Show</span>
        <b-form-select
          class="form-control"
          style="width: 20%"
          v-model="perPage"
          :options="pageOptions"
          @change="onChangeEntries"
        ></b-form-select>
        <span style="margin-left: 1rem">entries</span>
      </div>
      <div class="d-flex align-items-center justify-content-end col">
        <label for="searchText" class="mx-3">Search: </label>
        <input
          id="searchText"
          type="text"
          v-model="searchText"
          class="form-control w-50"
          @change="getList"
        />
      </div>
    </div>
    <b-table
      class="table table-bordered w-100"
      hover
      responsive
      :items="listUsers"
      :fields="fields"
      :per-page="perPage"
      @sort-changed="sortCompare"
    >
      <template #cell(action)="data">
        <div class="d-flex justify-content-evenly">
          <button
            @click="
              $router.push({
                name: 'DetailUser',
                query: { id: data.item.id, type: 'edit' },
              })
            "
            class="btn btn-outline-primary btn-detail"
          >
            Detail
          </button>
          <button
            @click="showResetPassword(data.item.email)"
            class="btn btn-outline-dark btn-reset"
          >
            Reset Password
          </button>
        </div>
      </template>
    </b-table>
    <b-pagination
      :total-rows="totalItems"
      v-model="currentPage"
      :per-page="perPage"
      class="my-0"
      aria-controls="my-table"
      @input="changePage"
    ></b-pagination>
    <div class="resetAll text-center">
      <button
        class="btn btn-dark"
        @click="resetAllUser"
        :disabled="disableReset"
      >
        Reset All
      </button>
    </div>
    <v-dialog v-model="showResetConfirm" width="500" persistent>
      <div class="content-dialog">
        <div v-if="!isSubmitReset">
          <h3>ต้องการรีเซ็ต Password หรือไม่ ?</h3>
          <div class="text-center">
            <button class="btn-back mr-5" @click="resetPassWord">ตกลง</button>
            <button class="btn-back" @click="hideDialog">ปิด</button>
          </div>
        </div>
        <div v-else>
          <h3>{{ resetSuccess ? resetSuccess : resetFail }}</h3>
          <div class="text-center">
            <button class="btn-back" @click="hideDialog">ปิด</button>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import UserService from "@/services/api/user.service";
import DefaultListViewData from "@/views/defaultListViewData";
export default {
  data() {
    return {
      ...DefaultListViewData,
      isBusy: false,
      listUsers: [],
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "firstName",
          label: "First Name",
          thClass: "text-start",
          tdClass: "text-start",
          class: "col-firstname",
          sortable: true,
        },
        {
          key: "lastName",
          label: "Last Name",
          thClass: "text-start",
          tdClass: "text-start",
          class: "col-lastname",
          sortable: true,
        },
        {
          key: "email",
          label: "Email",
          thClass: "text-start",
          tdClass: "text-start",
          class: "col-email",
          sortable: true,
        },
        {
          key: "permissions",
          label: "Permission",
          thClass: "text-start",
          tdClass: "text-start",
          class: "col-permission",
          sortable: true,
        },
        {
          key: "brand",
          label: "Brand",
          thClass: "text-start",
          tdClass: "text-start",
          class: "col-brand",
        },
        {
          key: "status",
          label: "Status",
          thClass: "text-start",
          tdClass: "text-start",
          class: "col-status",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      showResetConfirm: false,
      emailForReset: null,
      isSubmitReset: false,
      resetSuccess: null,
      resetFail: null,
      resetAllInterval: null,
      disableReset: false,
    };
  },
  mounted() {
    this.isLoading = true;
    this.getList(this.sort);
  },
  methods: {
    async getList(sort) {
      try {
        const param = {
          currentPage: this.currentPage,
          limit: this.perPage || this.totalItems,
          sortColumn: sort.key || "id",
          sortType: sort.type || "desc",
          key: this.searchText,
        };
        await UserService.getListUsers(param)
          .then((res) => {
            const data = res.data;
            this.totalItems = data.totalItems;
            this.listUsers = data.users.map((i) => {
              return {
                ...i,
                brand: i.brand.join(", "),
                permissions: i.permissions.join(", "),
                status: i.status === "ACTIVE" ? "Active" : "Inactive",
              };
            });
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    async resetPassWord() {
      try {
        const body = {
          userIdentity: this.emailForReset,
        };
        await UserService.resetPasswordUser(body)
          .then((res) => {
            const data = res.data;
            this.isSubmitReset = true;
            if (data.status === "success") {
              this.resetSuccess = `รีเซ็ตรหัสผ่านเรียบร้อยลิงค์จะถูกส่งไปที่ ${this.emailForReset}`;
            } else {
              this.resetFail = data.message;
            }
          })
          .catch((err) => {
            this.isSubmitReset = true;
            this.resetFail = `ไม่สามารถรีเซ็ตรหัสผ่านได้`;
            console.log("Error: ", err);
          });
      } catch (ex) {
        this.isSubmitReset = true;
        this.resetFail = `เกิดข้อผิดพลาดบางประการ`;
        console.log("Error: ", ex);
      }
    },
    changePage() {
      this.getList(this.sort);
    },
    sortCompare(e) {
      let sortBy;
      if (e.sortBy === "firstName") {
        sortBy = "profile." + e.sortBy;
      } else if (e.sortBy === "lastName") {
        sortBy = "profile." + e.sortBy;
      } else if (e.sortBy === "id") {
        sortBy = "user." + e.sortBy;
      } else if (e.sortBy === "email") {
        sortBy = "user." + e.sortBy;
      }
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getList(this.sort);
    },
    onChangeEntries() {
      this.getList(this.sort);
    },
    showResetPassword(email) {
      this.emailForReset = email;
      this.showResetConfirm = true;
    },
    hideDialog() {
      this.emailForReset = null;
      this.resetSuccess = null;
      this.resetFail = null;
      this.isSubmitReset = false;
      this.showResetConfirm = false;
    },
    resetAllUser() {
      try {
        let index = 0;
        this.disableReset = true;
        const interval = setInterval(() => {
          if (index < this.listUsers.length) {
            this.emailForReset = this.listUsers[index].email;
            this.resetPassWord();
            index++;
          } else {
            this.disableReset = false;
            clearInterval(interval);
          }
        }, 5000);
      } catch (ex) {
        console.log("Error: ", ex);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  margin: 1rem 0;
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}

.resetAll {
  display: none;
}

.btn-reset {
  margin-left: 5px;
  width: 100%;
  max-width: 80px;
  font-size: 12px;
}
</style>
